/* eslint-disable */
import React, { useState, useEffect } from 'react'; // eslint-disable-next-line
import { Link, useLocation } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { general } from '../config/config';
import { copiriPortalRequest, getLanguagePackUrl } from '../api/api';
import { config } from '../config/config'; // eslint-disable-next-line
function Header() {
	const [expanded, setExpanded] = useState(false);
	const [pageLanguageContent, setPageLanguageContent] = useState([]); // eslint-disable-next-line
	const handleNavLinkClick = () => {
		setExpanded(false); // Close the navbar when a Nav.Link is clicked
	};
	useEffect(() => {
		getLanguagePack();
		// eslint-disable-next-line
	}, []);
	let location = useLocation();

	/* function to get the translated language text */
	function getLanguagePack() {
		let checkData = JSON.parse(localStorage.getItem('idiom'));
		if (checkData === null || checkData === undefined || checkData === '') {
			// if not store in local storage, call api to get it and store in local storage
			var getLanguageURL = getLanguagePackUrl();
			copiriPortalRequest(getLanguageURL, config.app_version, 'get')
				.then((response) => {
					if (response?.data?.WCS?.AAA) {
						setPageLanguageContent(response.data.WCS.AAA);
						localStorage.setItem('idiom', JSON.stringify(response.data.WCS));
					}
				})
				.catch((error) => {});
		} else {
			// if stores in localstorage
			if (checkData?.AAA) {
				setPageLanguageContent(checkData?.AAA);
			}
		}
	}
	return (
		<div className='navbar-area' id='navbar'>
			<Navbar expand='lg' expanded={expanded} onToggle={() => setExpanded(!expanded)}>
				<Container>
					<Link to='/' className='navbar-brand' onClick={() => setExpanded(false)}>
						<img src={general?.logo} alt='brand-1' width='75' />
					</Link>
					<Navbar.Toggle aria-controls='responsive-navbar-nav' />
					<Navbar.Collapse id='responsive-navbar-nav'>
						<Nav className='me-auto'>
							<ul className='navbar-nav'>
								<li className='nav-item'>
									<Link
										to='/'
										className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
										onClick={handleNavLinkClick}
									>
										{pageLanguageContent['AAA001'] ? pageLanguageContent['AAA001'] : ''}
									</Link>
								</li>
								<li className='nav-item'>
									<Link
										to={`/event-details/future/next`}
										className={`nav-link`}
										onClick={handleNavLinkClick}
										style={{ color: '#' + pageLanguageContent['AAANXC'] }}
									>
										{pageLanguageContent['AAANXT'] ? pageLanguageContent['AAANXT'] : ''}
									</Link>
								</li>
								<li className='nav-item'>
									<Link
										to='/history'
										className={`nav-link ${location.pathname === '/history' || location.pathname.includes('history') ? 'active' : ''}`}
										onClick={handleNavLinkClick}
									>
										{pageLanguageContent['AAA002'] ? pageLanguageContent['AAA002'] : ''}
									</Link>
								</li>
								<li className='nav-item'>
									<Link
										to='/future'
										className={`nav-link ${location.pathname === '/future' || location.pathname.includes('future') ? 'active' : ''}`}
										onClick={handleNavLinkClick}
									>
										{pageLanguageContent['AAA003'] ? pageLanguageContent['AAA003'] : ''}
									</Link>
								</li>
								<li className='nav-item'>
									<Link
										to='/details'
										className={`nav-link ${location.pathname === '/details' ? 'active' : ''}`}
										onClick={handleNavLinkClick}
									>
										{pageLanguageContent['AAA004'] ? pageLanguageContent['AAA004'] : ''}
									</Link>
								</li>
							</ul>
						</Nav>
					</Navbar.Collapse>
				</Container>
			</Navbar>
		</div>
	);
}
export default Header;
